<template>
  <div class="result-panel">
    <div class="result-stats">
      <div class="result-stat"><span><i class="bi bi-stopwatch" aria-hidden="true"></i> Süre</span><strong>{{ totalDuration }}</strong></div>
      <div class="result-stat correct"><span><i class="bi bi-check2" aria-hidden="true"></i> Doğru cevap</span><strong>{{ totalCorrect }}</strong></div>
      <div class="result-stat incorrect"><span><i class="bi bi-x" aria-hidden="true"></i> Yanlış cevap</span><strong>{{ totalInCorrect }}</strong></div>
    </div>
    <div v-if="ShowLevel" class="level-summary"><span>Test sonucuna göre seviyen</span><strong>{{ GetLevelTestPuan(totalCorrect) }}</strong></div>
    <h2 class="review-heading">Cevapların</h2>
    <div v-for="q in exercises" :key="q.id" class="answer-review">
      <div class="review-title"><span class="question-number">{{ q.sequence }}</span><div v-html="q.question"></div></div>
      <div class="review-details"><div><span class="detail-label">Cevabın</span><strong>{{ GetUserAnswer(q) }}</strong></div><div><span class="detail-label">Doğru cevap</span><strong>{{ GetRightAnswer(q) }}</strong></div><span class="answer-status" :class="IsSuccess(q) ? 'correct' : 'incorrect'"><i class="bi" :class="IsSuccess(q) ? 'bi-check2' : 'bi-x'" aria-hidden="true"></i>{{ IsSuccess(q) ? 'Doğru' : 'Yanlış' }}</span></div>
    </div>
  </div>
</template>
<script>
  import {GetLevelTextByCurrectPuan} from '@/common/test-helper';
  import {ConvertMiliSecoundToSecound} from '@/common/datetime-helper';
  export default {
    name: "ExcerciseTestResult2",
    props: {
      ExcerciseData:{
        type:Object,
      },
      ExcerciseUserAnswerData:{
        type:Object,
      },
      ShowLevel:{
        type:Boolean,
        default:false
      },
    },
    data() {
      return {
        totalDuration:'00:00:00',
        totalInCorrect:0,
        totalCorrect:0,
        userAnswers:[]
      };
    },
    computed: {
      exercises(){
        let result = [];
        if(this.ExcerciseData && this.ExcerciseData.length>0){
            result = this.ExcerciseData;
        }
        return result;
      },
      excerciseUserAnswerData(){
        let result = [];
        if(this.ExcerciseUserAnswerData && this.ExcerciseUserAnswerData.length>0){
            result = this.ExcerciseUserAnswerData;
        }
        return result;
      },
    },
    methods: {
      GetUserAnswer(question){
        if(!this.userAnswers || this.userAnswers.length==0) return;
        let id = question.id;
        let answer = this.userAnswers.find(x=>x.Id===id).Answer;
        return question.answers[answer];
      },
      GetRightAnswer(question){
        return question.answers[question.right];
      },
      IsSuccess(question) {
          if(!this.userAnswers || this.userAnswers.length==0) return;

          let id = question.id;
          let right = question.right;
          let answer = this.userAnswers.find(x=>x.Id===id).Answer;
          if (parseInt(answer,10) === parseInt(right,10))
            return true;
          else 
            return false;
      },
      
      QuestionControl(){
        this.totalCorrect = 0;
        this.totalInCorrect = 0;
        for (let i = 0; i < this.exercises.length; i++) {
          let data = this.exercises[i];
          let answer = this.userAnswers.find(x=>x.Id===data.id).Answer;  
          if(data.right===answer){
            this.totalCorrect++;
          }else{
            this.totalInCorrect++;
          }
        }
      },
      GetLevelTestPuan(value) {
          return '"'+GetLevelTextByCurrectPuan(value)+'"';
      },
    },
    watch: {
      ExcerciseUserAnswerData:function(value){
          if(value){
            this.userAnswers = JSON.parse(value.answerContent);
            this.QuestionControl();
            let d1 = new Date(value.finishDate);
            let d2 = new Date(value.beginDate);
            this.totalDuration = ConvertMiliSecoundToSecound((d1.getTime() - d2.getTime()));
          }
      }
    },
    
  };
  </script>
  
  <style scoped>
.result-panel { color:#24382e; }
.result-stats { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; }
.result-stat { padding:18px; border-radius:12px; background:#f5f7f4; }
.result-stat > span { display:block; font-size:.78rem; margin-bottom:8px; }
.result-stat strong { font-size:1.35rem; font-weight:700; overflow-wrap:anywhere; }
.correct { background:#edf5eb; color:var(--brand-primary-hover); }
.incorrect { background:#fcf0ed; color:#a34432; }
.level-summary { display:flex; align-items:center; justify-content:space-between; gap:16px; background:#f5f7f4; border:1px solid #e4eae4; padding:16px 20px; border-radius:12px; margin-top:16px; font-size:.88rem; }
.level-summary strong { color:var(--brand-link); font-size:1.25rem; }
.review-heading { font-size:1rem; font-weight:700; margin:28px 0 16px; }
.answer-review { border:1px solid #e4eae4; border-radius:12px; padding:18px; margin-top:12px; }
.review-title { display:flex; gap:12px; align-items:baseline; line-height:1.7; overflow-wrap:anywhere; }
.review-title > div { min-width:0; }
.review-title :deep(p:last-child) { margin-bottom:0; }
.review-title :deep(img) { max-width:100%; height:auto; }
.question-number { color:#637269; font-size:.8rem; flex-shrink:0; }
.review-details { display:grid; grid-template-columns:1fr 1fr auto; align-items:center; gap:16px; border-top:1px solid #edf0ed; padding-top:14px; margin-top:14px; }
.review-details strong { font-size:.88rem; font-weight:500; overflow-wrap:anywhere; }
.detail-label { display:block; color:#637269; font-size:.72rem; margin-bottom:4px; }
.answer-status { display:inline-flex; align-items:center; gap:4px; border-radius:20px; padding:5px 10px; font-size:.75rem; }
@media(max-width:575.98px) { .result-stats { gap:8px; } .result-stat { padding:12px 8px; } .result-stat > span { font-size:.7rem; } .result-stat strong { font-size:1rem; } .review-details { grid-template-columns:1fr 1fr; } .answer-status { justify-self:start; } .level-summary { flex-wrap:wrap; } }
</style>